import * as v from "valibot";

import { rpcContract } from "../rpc";

export const getPostRpcContract = rpcContract({
  name: "getPost",
  paramsSchema: v.object({
    postId: v.string(),
  }),
  resultSchema: v.object({
    id: v.string(),
    teaser: v.nullable(v.string()),
    mediaUrl: v.nullable(v.string()),
    mediaFileId: v.nullable(v.string()),
    mediaFileType: v.nullable(v.union([v.literal("image"), v.literal("video")])),
    status: v.union([v.literal("live"), v.literal("draft"), v.literal("planned")]),
    createdAt: v.string(),
    publishedAt: v.nullable(v.string()),
    startDate: v.nullable(v.string()),
    endDate: v.nullable(v.string()),
    worlds: v.array(
      v.object({
        id: v.string(),
        name: v.string(),
      }),
    ),
    brands: v.array(
      v.object({
        id: v.string(),
        name: v.string(),
      }),
    ),
    ctaData: v.nullable(
      v.object({
        callToAction: v.string(),
        url: v.string(),
      }),
    ),
    discountData: v.nullable(
      v.object({
        code: v.string(),
      }),
    ),
    faqBlocks: v.array(
      v.object({
        id: v.string(),
        question: v.string(),
        answer: v.string(),
      }),
    ),
    contentTier: v.picklist(["free", "premium"]),
    oneTimeProduct: v.optional(
      v.object({
        id: v.string(),
        priceCents: v.number(),
      }),
    ),
  }),
});

export type GetPostParams = v.InferOutput<(typeof getPostRpcContract)["paramsSchema"]>;
export type GetPostResult = v.InferOutput<(typeof getPostRpcContract)["resultSchema"]>;
